import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/TransformerBushingHighVoltageHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-22.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ctb { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .ctb-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .ctb-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .ctb-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .ctb-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .ctb-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .ctb-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .ctb-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .ctb-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .ctb-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .ctb-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .ctb-bc-item:hover { color: #EB2019; }
  .ctb-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .ctb-bc-sep img { width: 24px; height: 24px; display: block; }
  .ctb-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .ctb-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .ctb-main-section { padding: 80px 0 120px 0; }
  .ctb-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .ctb-article { flex: 1; min-width: 0; }

  .ctb-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .ctb-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .ctb-meta-item:last-child { border-right: none; padding-right: 0; }
  .ctb-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .ctb-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .ctb-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .ctb-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ctb-article-body p { margin-bottom: 20px; }
  .ctb-article-body p:last-child { margin-bottom: 0; }

  .ctb-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .ctb-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .ctb-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ctb-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .ctb-article-body ul li > span { flex: 1; }

  .ctb-article-body strong { font-weight: 600; color: #202020; }

  .ctb-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .ctb-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .ctb-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .ctb-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .ctb-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .ctb-nav-btn:hover { color: #EB2019; }
  .ctb-nav-btn img { width: 40px; height: 40px; display: block; }

  .ctb-share-icons { display: flex; align-items: center; gap: 20px; }
  .ctb-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .ctb-share-icon:hover { opacity: 0.85; }
  .ctb-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .ctb-sidebar { flex: 0 0 475px; }
  .ctb-sidebar-block { margin-bottom: 60px; }
  .ctb-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .ctb-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .ctb-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .ctb-recent-item:hover .ctb-recent-title { color: #EB2019; }
  .ctb-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .ctb-recent-body { flex: 1; min-width: 0; }
  .ctb-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .ctb-social-icons { display: flex; align-items: center; gap: 30px; }
  .ctb-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .ctb-social-icon:hover { opacity: 0.8; }
  .ctb-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .ctb-hero             { height: 350px; }
    .ctb-hero-content     { padding: 0 32px; }
    .ctb-hero-title       { font-size: 30px; }
    .ctb-hero-divider     { width: 100%; max-width: 479px; }
    .ctb-breadcrumb       { padding: 24px 0 0 0; }
    .ctb-breadcrumb-inner { padding: 0 32px; }
    .ctb-inner            { padding: 0 32px; }
    .ctb-main-section     { padding: 48px 0 60px 0; }
    .ctb-main-row         { flex-direction: column; gap: 48px; }
    .ctb-sidebar          { flex: none; width: 100%; }
    .ctb-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .ctb-hero             { height: 360px; }
    .ctb-hero-content     { padding: 0 16px; }
    .ctb-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .ctb-hero-divider     { width: 100%; }
    .ctb-hero-subtitle    { font-size: 14px; }
    .ctb-breadcrumb       { padding: 30px 0 0 0; }
    .ctb-breadcrumb-inner { padding: 0 16px; }
    .ctb-bc-item          { font-size: 14px; gap: 14px; }
    .ctb-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .ctb-bc-sep img       { width: 22px; height: 22px; }
    .ctb-inner            { padding: 0 16px; }
    .ctb-main-section     { padding: 30px 0 60px 0; }
    .ctb-main-row         { flex-direction: column; gap: 60px; }
    .ctb-sidebar          { flex: none; width: 100%; }
    .ctb-article-title    { font-size: 20px; margin-bottom: 15px; }
    .ctb-article-body     { font-size: 14px; }
    .ctb-article-body p   { margin-bottom: 15px; }
    .ctb-article-body ul  { margin: 0 0 20px 0; gap: 10px; }
    .ctb-article-body ul li { font-size: 14px; }
    .ctb-meta-item        { font-size: 14px; }
    .ctb-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .ctb-h2               { font-size: 16px; margin: 30px 0 10px 0; }
    .ctb-nav-btn img      { width: 24px; height: 24px; }
    .ctb-nav-btn          { font-size: 14px; }
    .ctb-share-icon img   { width: 34px; height: 34px; }
    .ctb-sidebar-title    { font-size: 20px; }
  }
`;

const recentPosts = [
  {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function HowToChooseTransformerBushingHighVoltage() {
  return (
    <div className="ctb">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="ctb-hero">
        <img className="ctb-hero-bg" src={HeroBgImg} alt="Transformer Bushing High Voltage Hero" />
        <div className="ctb-hero-overlay" />
        <div className="ctb-hero-content">
          <h1 className="ctb-hero-title">
            How to Choose the Right Transformer Bushing for High Voltage Applications?
          </h1>
          <hr className="ctb-hero-divider" />
          <p className="ctb-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="ctb-breadcrumb" aria-label="Breadcrumb">
        <div className="ctb-breadcrumb-inner">
          <a href="/" className="ctb-bc-item">Home</a>
          <span className="ctb-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="ctb-bc-item">News &amp; Updates</a>
          <span className="ctb-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ctb-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="ctb-main-section">
        <div className="ctb-inner">
          <div className="ctb-main-row">

            {/* ── ARTICLE ── */}
            <article className="ctb-article">

              {/* Meta bar */}
              <div className="ctb-meta-bar">
                <span className="ctb-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="ctb-meta-item"><img src={CalendarIcon} alt="date" /> April 28, 2025</span>
                <span className="ctb-meta-item"><img src={ClockIconImg} alt="time" /> 6:50 am</span>
                <span className="ctb-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="ctb-article-title">
                How to Choose the Right Transformer Bushing for High Voltage Applications?
              </h1>

              {/* Body */}
              <div className="ctb-article-body">

                <p>In high-voltage systems like Electrostatic Precipitators (ESPs), every part counts—particularly <strong>Transformer Bushings</strong>. These aren't just mechanical insulators but crucial links that assure safe and efficient current transfer from the transformer to external systems. For OEMs and plant operators in power, cement, steel, and other heavy industries, selecting the correct bushing is key to long-term system reliability, safety, and pollution control.</p>

                {/* Article image */}
                <img className="ctb-article-img" src={ArticleImg} alt="Transformer Bushing High Voltage" />

                <span className="ctb-h2">Why Transformer Bushings Matter</span>

                <p><a href="role-transformer-bushings-safe-power-transmission" className="ctb-red-link">Transformer Bushings</a> allow conductors to pass safely through grounded sections without electrical breakdown. High-voltage ESP systems must manage excessive voltage stress and high temperatures and usually perform in dusty, corrosive conditions. A wrong choice can lead to partial discharge, insulation failure, and, eventually, costly system downtime.</p>

                <span className="ctb-h2">1. Match Bushing Type with Voltage Class</span>

                <p>Start by matching the bushing's voltage rating with your T/R set. ESPs used in emission control applications typically range from 30kV to 150kV. Ensure that the bushing supports not just operational voltage but also short-duration overvoltages.</p>

                <p>ADOR POWERTRON's high-voltage T/R sets are deployed globally in some of the harshest industrial environments. The correct bushing ensures seamless current delivery from the transformer to the rectifier, supporting continuous and stable ESP operation.</p>

                <span className="ctb-h2">2. Choose the Right Insulation Medium</span>

                <p>Transformer Bushings come in two primary insulation types:</p>

                <ul>
                  <li><span>OIP (Oil-Impregnated Paper) – Traditional and robust but requires regular maintenance.</span></li>
                  <li><span>RIP (Resin-Impregnated Paper) – Maintenance-free, environmentally safe, no oil leakage risk.</span></li>
                </ul>

                <p>In ESP-based emission control systems, where uptime and safety are top priorities, RIP bushings are gaining preference due to their dry-type design and low environmental impact.</p>

                <span className="ctb-h2">3. Consider Environmental Conditions</span>

                <p>ADOR serves power, cement, and steel industries, often high-pollution zones. Bushings installed in these areas should offer high creepage distances and be designed for pollution performance (per IEC/IEEE standards).</p>

                <p>Also, ambient temperature variations and whether the application requires porcelain or composite-type bushings should be considered based on environmental resistance and safety needs.</p>

                <span className="ctb-h2">4. Focus on System Compatibility</span>

                <p>Transformer bushings must seamlessly integrate with your T/R design and software. At ADOR, bushings are carefully selected or custom-integrated to suit in-house control systems and third-party OEM software. This ensures fault-free performance, especially in precision-controlled ESP systems where electrical spikes or partial discharges can affect collection efficiency.</p>

                <span className="ctb-h2">5. Don't Overlook Maintenance Access</span>

                <p>Some bushings allow for online monitoring—partial discharge detection, oil level indicators, etc.—which help reduce unplanned downtime. Real-time data improves fault prediction and operational efficiency in mission-critical emission control systems.</p>

                <span className="ctb-h2">Final Thoughts</span>

                <p>Choosing the right <strong>Transformer Bushing</strong> isn't just about technical specs—it's about matching performance with the real-world demands of high-voltage ESP systems. From insulation type to pollution resistance and software compatibility, each decision affects your ability to maintain clean emissions, reduce downtime, and meet global compliance standards.</p>

                <p>At <strong>ADOR POWERTRON</strong>, our deep industry expertise, global footprint, and commitment to sustainable technology ensure we always help our clients make the right choice. Contact us now.</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="ctb-bottom-row">
                <div className="ctb-bottom-nav">
                  <a href="/news/understanding-transformer-bushings-types-functions" className="ctb-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/how-to-select-right-smps" className="ctb-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="ctb-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/how-to-choose-the-right-transformer-bushing-for-high-voltage-applications/" className="ctb-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fhow-to-choose-the-right-transformer-bushing-for-high-voltage-applications%2F&mode=login" className="ctb-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fhow-to-choose-the-right-transformer-bushing-for-high-voltage-applications%2F%26title%3DA%2520Buyer%25E2%2580%2599s%2520Guide%2520to%2520Transformer%2520Bushings%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fhow-to-choose-the-right-transformer-bushing-for-high-voltage-applications%2F" className="ctb-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="ctb-sidebar">

              {/* Recent Posts */}
              <div className="ctb-sidebar-block">
                <p className="ctb-sidebar-title">Recent Posts</p>
                <div className="ctb-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="ctb-recent-item">
                      <img src={post.img} alt={post.title} className="ctb-recent-img" />
                      <div className="ctb-recent-body">
                        <span className="ctb-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="ctb-sidebar-block">
                <p className="ctb-sidebar-title">Social Media</p>
                <div className="ctb-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="ctb-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="ctb-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}